<script setup>
import { Duration } from 'luxon'
import { computed } from 'vue'
import { useVideoShow } from '../use-video-show'
import { parseCustomDuration } from './utils'

const props = defineProps({
  transcriptRowData: {
    required: true
  },
  playerCurrentTime: {
    required: true
  }
})

const { playerRef } = useVideoShow()

const start = computed(() => Duration.fromObject(parseCustomDuration(props.transcriptRowData.start)))

const startText = computed(() => start.value.toFormat('mm:ss'))
const startSeconds = computed(() => start.value.as('seconds'))
const endSeconds = computed(() => Duration.fromObject(parseCustomDuration(props.transcriptRowData.end)).as('seconds'))
const active = computed(() => props.playerCurrentTime >= startSeconds.value && props.playerCurrentTime < endSeconds.value)

const onClick = () => {
  playerRef.value.currentTime(startSeconds.value)
}

</script>

<template>
  <div
    class="d-flex mb-4 border border-transparent rounded p-2"
    :class="{'border-primary' : active}"
    @click="onClick"
  >
    <div class="w-50px font-size-sm flex-shrink-0">
      <button
        class="btn btn-sm btn-link p-0"
      >
        {{ startText }}
      </button>
    </div>
    <div class="font-size-sm">{{ transcriptRowData.text }}</div>
  </div>
</template>
